<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    console.log("更新更新更新")
    sessionStorage.setItem('scanCodeUrl', location.href)
  }
}
</script>
<style lang="scss">
html,
body,
div,
ul,
li,
input,
button,
img,
textarea,
p,
h1,
a {
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  -webkit-tap-highlight-color: transparent; //禁用按压时有背景颜色
  box-sizing: border-box;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: #333;
}
body {
  background: #f7fbfc;
  font-size: 14px !important;
}
img {
  font-size: 0;
  line-height: 0;
}
.flex {
  display: flex;
  align-items: center;
}
.cursor {
  cursor: pointer;
}
.clean_float::after {
  content: "";
  height: 0;
  display: block;
  clear: both;
  zoom: 1;
}
.w_1200 {
  width: 1200px;
  margin: 0 auto;
}

.overflow_e {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.overflow_o {
  width: 258px;
  overflow: hidden;
  text-overflow: ellipsis;
  //white-space: nowrap;
}
</style>
